import type { SelectProps } from "antd";
import { Select } from "antd";
import React, { useState } from "react";
import type { DefaultOptionType } from "antd/lib/select";
import { Maybe } from "@graphql-tools/utils/typings/types";

interface AveliosMultiSelectProps<T> extends SelectProps<T> {
  getKey: (value: Maybe<any>) => string;
}

export function AveliosMultiSelect<T>({
  onDeselect,
  onClear,
  getKey,
  ...props
}: AveliosMultiSelectProps<T>) {
  const [, setKeysToIgnore] = useState<string[]>([]);

  return (
    <Select
      onDeselect={(val: any, options: DefaultOptionType) => {
        setKeysToIgnore((prevState) => {
          if (prevState.includes(getKey(val))) {
            return prevState.filter((v) => v !== getKey(val));
          } else {
            onDeselect?.(val, options);
            return prevState;
          }
        });
      }}
      onClear={() => {
        // @ts-ignore
        setKeysToIgnore(props.value?.map((v) => getKey(v)) ?? []);
        onClear?.();
      }}
      {...props}
    />
  );
}
